module.exports = __webpack_public_path__ + "static/Fluke@2x.58173df4.png";